module.exports = "/_next/static/images/icon_weather_42-494b48e0955c9bb404bf262d713d4575.svg";